<script setup>
import { reactive, ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAppStore } from '../store/app';
import { useAdminStore } from '../store/admin';

const store = useAppStore();
const router = useRouter();
const adminStore = useAdminStore();

const showNewUserModal = ref(false);

const isActive = ref({
  dashboard: true,
  addCustomer: false,
  allCustomer: false,
  addNewProduct: false,
});

const selectedItemIdx = ref(0);

onMounted(() => {
  if (router.currentRoute.value.path === '/') {
    isActive.value = { ...isActive, dashboard: true };
  }
});

const menueItems = reactive([
  {
    title: 'Products',
    icon: 'mdi-view-dashboard',
    option: 'dashboard',
  },
  {
    title: 'All Customers',
    icon: 'mdi-account-group',
    option: 'allCustomer',
  },
]);

/**
 * Toggle New Product Modal: Toggles form.
 */
const onToggleNewUserModal = () => (showNewUserModal.value = !showNewUserModal.value);

/**
 * Toggle New Product Modal: Toggles form.
 */

/**
 * Depending on what navigation item is selected this will
 * change accordingly.
 */
const onSetCurrentNavigation = ({ option }) => {
  switch (option) {
    case 'dashboard':
      router.push('/');
      store.setSelectedProduct({ productName: '' }); // Set to default
      isActive.value = { ...isActive, dashboard: !isActive.value.dashboard };
      break;
    case 'addCustomer':
      onToggleNewUserModal();
      store.setSelectedProduct({ productName: '' }); // Set to default
      isActive.value = { ...isActive, addCustomer: !isActive.value.addCustomer };
      break;
    case 'allCustomer':
      router.push('/all-customer-list');
      store.setSelectedProduct({ productName: '' }); // Set to default
      isActive.value = { ...isActive, allCustomer: !isActive.value.allCustomer };
      break;
    default:
      break;
  }
};
const rail = ref(true);
</script>

<template>
  <v-navigation-drawer app permanent class="nav" @click="rail = false" :rail="rail">
    <v-list height="68px" border="none" class="nav__list-head">
      <v-list-item
        @click="router.push('/')"
        :prepend-avatar="adminStore.adminProfile?.picture"
        size="100px">
        <v-list-item-title class="nav__username"
          >{{ adminStore.adminProfile?.given_name }}
          {{ adminStore.adminProfile?.family_name }}👋</v-list-item-title
        >
        <v-list-item-subtitle class="nav__user-email">{{
          adminStore.adminProfile?.email
        }}</v-list-item-subtitle>
        <template v-slot:append>
          <v-btn variant="text" icon="mdi-chevron-left" @click.stop="rail = !rail"></v-btn>
        </template>
      </v-list-item>
    </v-list>

    <v-divider class="nav__divider"></v-divider>

    <v-list density="compact" nav>
      <v-item-group mandatory v-model="selectedItemIdx" color="primary">
        <v-list-item
          v-for="(menu, idx) in menueItems"
          :active="idx == selectedItemIdx"
          :key="menu"
          :title="menu.title"
          :value="menu"
          @click="onSetCurrentNavigation({ option: menu.option }), (selectedItemIdx = idx)"
          active-class="activeMenu">
          <template v-slot:prepend>
            <v-icon :icon="menu.icon"></v-icon>
          </template>
        </v-list-item>
      </v-item-group>
    </v-list>
  </v-navigation-drawer>
</template>

<style lang="scss" scoped></style>
